'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import ff from '@/modules/shared/lib/feature-flags';
import { isBuilderService, isNetworkService } from '@/modules/shared/types/services';
import { filterBySearch } from '../../lib/utils';
import { EmptyStateService } from '../empty-state-service/empty-state-service';
import { ServicesCategorySection } from '../services-category-section';
import { ServicesFeaturedSection } from '../services-featured-section';
import { useServicesFiltersContext } from '../services-filters/services-filters-context';
import type { EnrichedService } from '../../types';
interface ServicesPageContentProps {
  enrichedServices: EnrichedService[];
}
function ServicesPageContent(t0) {
  const $ = _c(21);
  const {
    enrichedServices
  } = t0;
  const {
    search: contextSearch
  } = useServicesFiltersContext();
  const search = ff.SERVICES_LISTING_FILTERS_ENABLED ? contextSearch : "";
  let t1;
  if ($[0] !== enrichedServices || $[1] !== search) {
    let t2;
    if ($[3] !== search) {
      t2 = es => filterBySearch([es.service], search).length > 0;
      $[3] = search;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = enrichedServices.filter(t2);
    $[0] = enrichedServices;
    $[1] = search;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const filteredServices = t1;
  let t2;
  if ($[5] !== filteredServices) {
    t2 = filteredServices.filter(_temp);
    $[5] = filteredServices;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const builderServices = t2;
  let t3;
  if ($[7] !== filteredServices) {
    t3 = filteredServices.filter(_temp2);
    $[7] = filteredServices;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const networkServices = t3;
  let featured;
  if ($[9] !== builderServices || $[10] !== networkServices) {
    featured = [];
    let t4;
    if ($[12] !== builderServices) {
      t4 = builderServices.at(0);
      $[12] = builderServices;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    const firstBuilder = t4;
    let t5;
    if ($[14] !== networkServices) {
      t5 = networkServices.at(0);
      $[14] = networkServices;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    const firstNetwork = t5;
    if (firstBuilder !== undefined) {
      featured.push(firstBuilder);
    }
    if (firstNetwork !== undefined) {
      featured.push(firstNetwork);
    }
    $[9] = builderServices;
    $[10] = networkServices;
    $[11] = featured;
  } else {
    featured = $[11];
  }
  const featuredServices = featured;
  const isEmpty = builderServices.length === 0 && networkServices.length === 0;
  let t4;
  if ($[16] !== builderServices || $[17] !== featuredServices || $[18] !== isEmpty || $[19] !== networkServices) {
    t4 = <div className="flex flex-col gap-10">{isEmpty ? <EmptyStateService title="No services found" description="There are no services available for this combination of filters" /> : <>{featuredServices.length > 0 && <ServicesFeaturedSection services={featuredServices} />}{builderServices.length > 0 && <ServicesCategorySection title="Builders" services={builderServices} />}{networkServices.length > 0 && <ServicesCategorySection title="Networks" services={networkServices} />}</>}</div>;
    $[16] = builderServices;
    $[17] = featuredServices;
    $[18] = isEmpty;
    $[19] = networkServices;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
}
function _temp2(es_1) {
  return isNetworkService(es_1.service);
}
function _temp(es_0) {
  return isBuilderService(es_0.service);
}
export { ServicesPageContent };